import {HTTP} from "../http";

export default {
    namespaced: true,

    state: {
        loading: false,
        categories: null
    },

    mutations: {
        setLoading(state, loading) {
            state.loading = loading;
        },

        set(state, categories) {
            state.categories = categories;
        }
    },

    actions: {
        load({commit}) {
            commit('setLoading', true);

            return HTTP.get('/categories')
                .then(resp => commit('set', resp.data))
                .then(() => commit('setLoading', false))
                .catch(err => commit('error/set', err.response, { root: true }));
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/category.js